import { EC2_REGIONS_MAP, INSTANCE_TYPES_MAP } from '@/views/Admin/Transcoders/transcoders.table'

export const AWS_REGION_OPTIONS = Object.entries(EC2_REGIONS_MAP).map(
  ([value, { text, region }]) => ({
    value,
    label: `${text} (${value})`,
    region
  })
)

export const INSTANCE_TYPE_OPTIONS = Object.entries(INSTANCE_TYPES_MAP)
  .map(([value, label]) => ({
    value,
    label
  }))
  .sort((a, b) => a.label.localeCompare(b.label))

export const INPUT_TYPES = ['WOWZA', 'ZIXI']
